import { render, staticRenderFns } from "./StatsIcons.vue?vue&type=template&id=73f24f78&scoped=true&"
import script from "./StatsIcons.vue?vue&type=script&lang=js&"
export * from "./StatsIcons.vue?vue&type=script&lang=js&"
import style0 from "./StatsIcons.vue?vue&type=style&index=0&id=73f24f78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f24f78",
  null
  
)

export default component.exports